// Correo de soporte de la app: lo usa Ajustes (y es el mismo de Footer y
// SuscripcionGate). La pausa por inactividad ya NO lo usa: va a WHATSAPP_SOPORTE.
export const SOPORTE = "sebastian@smardx.com";

// Los médicos le escriben a Sebastián por WhatsApp, no por correo (memoria
// feedback_medicos_hablan_por_whatsapp; #1588 R32 usa el mismo número). La pausa
// por inactividad manda acá, nunca a "responde este correo".
export const WHATSAPP_SOPORTE = "https://wa.me/56968426546";
